import { useAuth } from "../context/AuthContext";
import { ShieldAlert, ArrowLeftRight } from "lucide-react";

/**
 * Banner sticky visibile quando un SuperAdmin sta impersonando un utente.
 * Si auto-nasconde quando non c'è impersonation attiva.
 */
const ImpersonationBanner = () => {
  const { impersonationInfo, user, endImpersonation } = useAuth();
  if (!impersonationInfo) return null;

  const nome = user?.nome || user?.username || "utente";
  const ruolo = user?.ruolo || "";
  const expires = impersonationInfo.expiresAt
    ? impersonationInfo.expiresAt.toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" })
    : "";

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[10000] bg-gradient-to-r from-red-600 to-rose-600 text-white shadow-xl border-b-2 border-red-800"
      data-testid="impersonation-banner"
    >
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <ShieldAlert className="h-5 w-5 flex-shrink-0 animate-pulse" />
          <div className="min-w-0">
            <p className="text-sm font-bold truncate">
              MODALITÀ IMPERSONATION — Stai operando come <span className="underline">{nome}</span>
              {ruolo && <span className="opacity-80"> ({ruolo})</span>}
            </p>
            <p className="text-[11px] opacity-90 truncate">
              SuperAdmin: {impersonationInfo.superadminEmail}
              {expires && ` · scade alle ${expires}`}
            </p>
          </div>
        </div>
        <button
          onClick={endImpersonation}
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-white text-red-600 font-bold text-xs hover:bg-red-50 transition-colors flex-shrink-0"
          data-testid="end-impersonation-btn"
        >
          <ArrowLeftRight className="h-3.5 w-3.5" />
          Torna a SuperAdmin
        </button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
